import { validators } from '../../utils/validators';

const validate = values => {
    const { REQUIRED } = validators;
    const errors = {};
    if (REQUIRED(values.cardType)) {
        errors.cardType = 'Please enter card type';
    }
    if (REQUIRED(values.cardNature)) {
        errors.cardNature = 'Please enter card nature';
    }
    if (!(values.isDomestic === true || values.isDomestic === false)) {
        errors.isDomestic = 'Please select domestic options';
    }
    return errors;
};

export default validate;
